import { httpRequest } from '../request';

// 获取国家/语言
export function getSiteMapList() {
  return httpRequest({
    url: 'common/site/map',
    method: 'post'
  });
}